module.exports = __webpack_public_path__ + "static/media/icon-shrink-order-lg.e4d0bfc0.svg";